import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Modal,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Heading,
  ModalFooter,
  ModalButtonGroup,
} from '@frontend/legacy-components';

import { invitesSkippedModal } from './data/actions';
import { getIsInvitesSkippedModalOpen } from './data/selectors';

export const InvitesSkippedModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsInvitesSkippedModalOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => dispatch(invitesSkippedModal.close())}
      size="md"
    >
      <ModalContent>
        <ModalCloseButton />
        <ModalBody px={4} pt={6}>
          <VStack spacing={1} align="center">
            <img
              width="88px"
              height="77px"
              src="https://s3.amazonaws.com/static.paperlessparts.com/images/invite-icon.png"
              alt="invite icon"
            />
            <Heading>Skip Invites</Heading>
            <Text textAlign="center" size="lg">
              You can always invite your team later from the Team page.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="center" border="none" pb={4}>
          <ModalButtonGroup>
            <Button
              variant="secondary"
              onClick={() => dispatch(invitesSkippedModal.close())}
            >
              Done
            </Button>
          </ModalButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
